import React, { useEffect, useState } from "react";
import AnalysisSnapshotContent from "./AnalysisSnapshotContent";

export default function LearningPanel({ symbol, timeframe, analysis }) {
  const market = symbol?.includes("Boom") ? "BOOM" : "CRASH";
  const [minimized, setMinimized] = useState(false);
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 768);
  const [pos, setPos] = useState(() => ({
    x: 16,
    y: 76,
  }));
  const [dragging, setDragging] = useState(false);
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const onMouseDown = (event) => {
    if (isMobile) {
      return;
    }

    setDragging(true);
    setOffset({
      x: event.clientX - pos.x,
      y: event.clientY - pos.y,
    });
  };

  const onMouseMove = (event) => {
    if (!dragging) {
      return;
    }

    setPos({
      x: event.clientX - offset.x,
      y: event.clientY - offset.y,
    });
  };

  const onMouseUp = () => setDragging(false);

  return (
    <div
      onMouseMove={onMouseMove}
      onMouseUp={onMouseUp}
      style={styles.root(pos, minimized, isMobile)}
    >
      <div onMouseDown={onMouseDown} style={styles.header(isMobile)}>
        <div style={styles.headerCopy}>
          <div style={styles.kicker}>Market Monitor</div>
          <div style={styles.title}>Spike AI Panel</div>
          <div style={styles.subtitle}>
            {symbol} | {timeframe / 60}m
          </div>
        </div>

        <div style={styles.headerActions}>
          <div style={styles.marketBadge(market)}>{market}</div>
          <button
            onClick={() => setMinimized((current) => !current)}
            style={styles.toggleButton}
            type="button"
          >
            {minimized ? "+" : "-"}
          </button>
        </div>
      </div>

      {!minimized ? (
        <div style={styles.body}>
          <AnalysisSnapshotContent analysis={analysis} compact />
        </div>
      ) : null}
    </div>
  );
}

const styles = {
  root: (pos, minimized, isMobile) => ({
    position: "fixed",
    left: isMobile ? 8 : pos.x,
    right: isMobile ? 8 : "auto",
    top: isMobile ? "auto" : pos.y,
    bottom: isMobile ? 8 : "auto",
    width: isMobile ? "auto" : minimized ? 148 : 332,
    maxWidth: isMobile ? "none" : "calc(100vw - 32px)",
    maxHeight: "none",
    overflow: "visible",
    padding: 3,
    borderRadius: 16,
    border: "1px solid rgba(74, 115, 170, 0.38)",
    background:
      "linear-gradient(180deg, #091225 0%, #111b31 100%)",
    color: "#e5e7eb",
    boxShadow: "0 16px 36px rgba(2, 6, 23, 0.42)",
    backdropFilter: "blur(14px)",
    zIndex: 999999,
    fontFamily: "'IBM Plex Sans', 'Segoe UI', Tahoma, sans-serif",
    animation: "panelFloatIn 260ms ease-out",
  }),
  header: (isMobile) => ({
    cursor: isMobile ? "default" : "move",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: 6,
    padding: "3px 2px 8px",
    borderBottom: "1px solid rgba(63, 83, 120, 0.6)",
  }),
  body: {
    marginTop: 6,
    display: "grid",
    gap: 6,
    paddingBottom: 1,
  },
  headerCopy: {
    display: "grid",
    gap: 3,
    minWidth: 0,
  },
  headerActions: {
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  kicker: {
    fontSize: 10,
    letterSpacing: "0.16em",
    textTransform: "uppercase",
    color: "#48b7ff",
    fontWeight: 800,
  },
  title: {
    marginTop: 0,
    fontSize: 13,
    fontWeight: 800,
    color: "#ffffff",
    lineHeight: 1.1,
  },
  subtitle: {
    marginTop: 0,
    fontSize: 9,
    letterSpacing: "0.06em",
    color: "#c7d3e7",
    textTransform: "uppercase",
  },
  marketBadge: (market) => ({
    minWidth: 50,
    height: 24,
    padding: "0 8px",
    borderRadius: 999,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background:
      market === "BOOM"
        ? "rgba(18, 90, 54, 0.3)"
        : "rgba(96, 32, 46, 0.28)",
    border:
      market === "BOOM"
        ? "1px solid rgba(49, 196, 114, 0.45)"
        : "1px solid rgba(210, 79, 98, 0.45)",
    color: market === "BOOM" ? "#a7f3c4" : "#ff8ca0",
    fontSize: 10,
    fontWeight: 800,
    letterSpacing: "0.12em",
    textTransform: "uppercase",
  }),
  toggleButton: {
    minWidth: 22,
    height: 22,
    borderRadius: 999,
    border: "1px solid rgba(82, 105, 143, 0.58)",
    background: "rgba(16, 26, 45, 0.92)",
    color: "#d8e4f8",
    cursor: "pointer",
    fontSize: 12,
    fontWeight: 800,
    lineHeight: 1,
  },
};
